import { Button, Col, Modal, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
// import { useState } from "react";
import { ImageUrl } from "../config/helpers";

const SystemRejectModal = ({
  systemRejectModal = false,
  setSystemRejectModal,
  setSystemMessageModal,
  banUser,
  setRejectionReason,
  rejectionReason,
}) => {
  // const [loading, setLoading] = useState(false);
  return (
    <div>
      <Modal
        centered
        open={systemRejectModal}
        footer={null}
        onCancel={() => setSystemRejectModal(false)}
      >
        <div className="flex flex-col justify-center items-center bg-white py-4">
          <img src={ImageUrl("warning.png")} alt="warning" />
          <h3 className="font-tavi text-3xl text-customBlack max-desktop:text-xl max-sm:text-lg text-center my-4 font-semibold">
            System Message
          </h3>
          <TextArea
            placeholder="Enter Rejection Reason"
            className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
            autoComplete={false}
            type="text"
            rows={5}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
          <Row justify="center" className="w-full">
            <Col lg={12}>
              <Button
                htmlType="submit"
                className="uppercase bg-button text-black rounded-lg text-sm font-bold max-2xl:text-xs mt-4 w-40 2xl:w-52 h-12 2xl:h-16"
                onClick={() => {
                  banUser("REJECTED");
                }}
                disabled={rejectionReason === ""}
              >
                {/* {loading ? "LOADING..." : "submit & reject"} */}
                submit & reject
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default SystemRejectModal;
